import React, { PureComponent } from 'react';
import { Loader } from 'react-loaders';
import { getRequest, postRequest, putRequest } from '../../api/ApiService';
import Auth from '../../routes/Auth';
import Teams from '../../api/Teams';
import { Modal } from "react-bootstrap";

import MarketShareVideo from '../../containers/assets/goals-and-targets-market-share.mp4';
import RevenuesVideo from '../../containers/assets/goals-and-targets-revenues.mp4';
import GrossMarginsVideo from '../../containers/assets/goals-and-targets-gross-margins.mp4';
import SharePriceVideo from '../../containers/assets/goals-and-targets-share-price.mp4';
import RoeVideo from '../../containers/assets/goals-and-targets-roe.mp4';
import RoaVideo from '../../containers/assets/goals-and-targets-roa.mp4';
import EpsVideo from '../../containers/assets/goals-and-targets-eps.mp4';

import {
  Wrapper,
  Title,
  Form,
  Description,
  InfoTooltip,
  ModalVideoWrapper,
  PlayPauseButton,
  CloseModalVideoButton
} from './styles';
import FinancialTargets from '../dashboard/FinancialTargets';

import InfoTooltipIcon from '../../containers/assets/info-tooltip.png';

const videos = {
  'Market Share': MarketShareVideo,
  'Revenues': RevenuesVideo,
  'Gross Margins': GrossMarginsVideo,
  'Share Price': SharePriceVideo,
  'ROE': RoeVideo,
  'ROA': RoaVideo,
  'EPS': EpsVideo,
};

class GoalsAndTargets extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      financialTargets: [],
      data: {},
      loaded: false,
      formLoading: false,
      alreadySaved: false,
      isModalShown: false,
      isVideoPlaying: false,
      selectedVideo: null
    };

    this.videoRef = null;
  }

  handlePlayPause = () => {
    if (this.videoRef) {
      if (this.state.isVideoPlaying) {
        this.videoRef.pause();
      } else {
        this.videoRef.play();
      }
      this.setState({ isVideoPlaying: !this.state.isVideoPlaying });
    }
  };

  openModal = (videoSrc) => {
    this.setState({
      isModalShown: true,
      selectedVideo: videoSrc,
    });
  };

  closeModal = () => {
    this.setState({
      isModalShown: false,
      isVideoPlaying: false
    });
  };

  onHelpIconClick = (field) => {
    if (videos[field]) {
      this.openModal(videos[field]);
    }
  };

  get activeRound() {
    const { currentRound, roundInUrl } = this.props;

    return Number(roundInUrl || currentRound);
  }

  componentDidMount() {
    const courseId = Number(Auth.getCourseId());

    getRequest(`${process.env.REACT_APP_API_URL}v2/games/targets/?course=${courseId}`)
      .then(res => {
        this.setState({
          financialTargets: res.body,
          loaded: true,
        });
      })
      .catch(err => { });
  }

  getData = res => {
    const currentRound = this.currentRound;
    const roundId = currentRound ? Number(currentRound.id) : 0;
    const currentTeam = Teams.currentTeam();
    const teamId = Number(currentTeam.id);
    const courseId = Number(Auth.getCourseId());
    const userId = Number(Auth.getUserId());

    return res && res.results ? res.results.find(i => (
      Number(i.round) === roundId
      && Number(i.user) === userId
      && Number(i.course) === courseId
      && Number(i.team) === teamId
    )) || null : null;
  }

  getFormattedData = res => {
    const values = this.getData(res);
    const data = {
      id: values ? Number(values.id) : null,
    };
    const columns = this.columns;

    for (const column of columns) {
      const field = column[2];
      data[field] = 0;

      if (values && values[field]) {
        data[field] = Number(values[field]);
      }

      const callback = column[4];
      data[field] = callback(data[field]).toFixed(2);
    }

    return data;
  }

  get columns() {
    const activeRound = this.activeRound;

    if (activeRound === 1 || activeRound === 2) {
      return [
        ['Market Share', '%', 'market_share', this.percentToValue, this.valueToPercent],
        ['Revenues', '$ (million)', 'net_revenues', this.millionToValue, this.valueToMillion],
        ['Gross Margins', '%', 'gross_margins', this.percentToValue, this.valueToPercent],
        ['Share Price', '$', 'share_price', this.asIsValue, this.asIsValue],
      ];
    }

    if (activeRound === 3) {
      return [
        ['Revenues', '$ (million)', 'net_revenues', this.millionToValue, this.valueToMillion],
        ['Gross Margins', '%', 'gross_margins', this.percentToValue, this.valueToPercent],
        ['Return On Equity', '%', 'roe', this.percentToValue, this.valueToPercent],
        ['Return On Assets', '%', 'roa', this.percentToValue, this.valueToPercent],
      ];
    }

    if (activeRound === 4) {
      return [
        ['Return On Equity', '%', 'roe', this.percentToValue, this.valueToPercent],
        ['Return On Assets', '%', 'roa', this.percentToValue, this.valueToPercent],
        ['Earnings Per Share', '$', 'earnings_per_share', this.asIsValue, this.asIsValue],
        ['Share Price', '$', 'share_price', this.asIsValue, this.asIsValue],
      ];
    }

    return [];
  }

  get currentRound() {
    const { rounds } = this.props;
    const activeRound = this.activeRound;

    return rounds.find(i => Number(i.number) === activeRound);
  }

  get isReadOnly() {
    const round = this.currentRound;
    return !(round ? (
      round.is_started === true
      && round.is_finished === false
      && round.should_be_finished === false
    ) : false);
  }

  getValue = field => {
    const { data } = this.state;

    if (!(field in data)) {
      return '';
    }

    return data[field];
  }

  setValue = (e, field) => {
    const { data } = this.state;

    if (!(field in data)) {
      return;
    }

    const value = e.target.value;

    this.setState({
      data: {
        ...data,
        [field]: value,
      },
    });
  }

  formatValue = field => {
    const { data } = this.state;

    if (!(field in data)) {
      return;
    }

    let value = Number(data[field]);
    if (isNaN(value)) {
      value = 0;
    }
    value = value.toFixed(2);
    if (value !== data[field]) {
      this.setState({
        data: {
          ...data,
          [field]: value,
        },
      });
    }
  }

  percentToValue = percent => {
    return percent / 100;
  }

  valueToPercent = value => {
    return value * 100;
  }

  millionToValue = million => {
    return million * 1000000;
  }

  valueToMillion = value => {
    return value / 1000000;
  }

  asIsValue = value => {
    return value;
  }

  save = () => {
    this.setState({
      formLoading: true,
    });

    const currentRound = this.currentRound;
    const roundId = currentRound ? Number(currentRound.id) : 0;
    const currentTeam = Teams.currentTeam();
    const teamId = Number(currentTeam.id);
    const courseId = Number(Auth.getCourseId());
    const userId = Number(Auth.getUserId());

    const { data } = this.state;
    const preparedData = {
      round: roundId,
      user: userId,
      course: courseId,
      team: teamId,
      market_share: 0,
      net_revenues: 0,
      gross_margins: 0,
      share_price: 0,
      roe: 0,
      roa: 0,
      earnings_per_share: 0,
    };
    const columns = this.columns;

    for (const [k, v] of Object.entries(data)) {
      const column = columns.find(i => i[2] === k);
      if (column) {
        const callback = column[3];
        preparedData[k] = callback(Number(v));
      }
    }

    let apiRequest = postRequest;
    let url = `${process.env.REACT_APP_API_URL}v2/games/goaltargets/`;
    if (!!data.id) {
      apiRequest = putRequest;
      url = `${url}${data.id}/`;
    }

    apiRequest(url)
      .send(preparedData)
      .then(res => {
        getRequest(`${process.env.REACT_APP_API_URL}v2/games/goaltargets/`)
          .then(res => {
            const data = this.getFormattedData(res.body);
            const values = this.getData(res.body);
            const alreadySaved = !!values;

            this.setState({
              formLoading: false,
              alreadySaved,
              data,
            });
          })
          .catch(err => { });
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      financialTargets,
      formLoading,
      isModalShown,
      isVideoPlaying
    } = this.state;
    const activeRound = this.activeRound;

    return loaded ? (
      <Wrapper>
        <Modal show={isModalShown} onHide={this.closeModal} className="goals-and-targets-modal">
          <Modal.Body>
            <ModalVideoWrapper className={isVideoPlaying ? 'is-playing' : ''}>
              <video
                ref={(ref) => { this.videoRef = ref; }}
                src={this.state.selectedVideo}
                alt="Welcome Video"
                onClick={this.handlePlayPause}
                onEnded={() => this.setState({ isVideoPlaying: false })}
                style={{ width: '100%', borderRadius: 10 }}
              />
              <PlayPauseButton onClick={this.handlePlayPause}>
                {isVideoPlaying ? '❚❚' : '▶'}
              </PlayPauseButton>
              <CloseModalVideoButton onClick={this.closeModal}>×</CloseModalVideoButton>
            </ModalVideoWrapper>
          </Modal.Body>
        </Modal>
        <Title>Set Team Goals &amp; Targets</Title>
        {formLoading && (
          <Form height="232px">
            <Loader type="ball-scale-ripple" active />
          </Form>
        )}
        <Description>
          Below shows the financial targets to hit in each year. Note that a few financial
          metrics are only relevant in certain years. Use the information here as references
          to set your team goals.
        </Description>
        <Form maxWidth="800px">
          <FinancialTargets
            round={activeRound}
            financialTargets={financialTargets}
            showTableOnly={true}
            showFullTable={true}
            hideTitle={true}
            padding="0px"
            onHelpIconClick={this.onHelpIconClick}
          />
        </Form>
      </Wrapper>
    ) : (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    );
  }

}

export default GoalsAndTargets;



// WEBPACK FOOTER //
// ./src/components/goals-and-targets/index.js